import { GraphComponent } from "components/utility/GraphComponent";
import { UIComp } from "model/Datatypes";
import React from "react";

interface ILargeCard {
  component: UIComp;
}

export const LargeCard: React.FC<ILargeCard> = ({ component }) => {
  return (
    <div className="h-full w-full px-3 2xl:py-5 pb-5">
      <div className="bg-white mt-4 h-full rounded-md">
        <GraphComponent graphComp={component} />
      </div>
    </div>
  );
};
